var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "api-layer" }, [
    _c("fieldset", [
      _c("legend", [_vm._v("RoomUser")]),
      _c(
        "div",
        {
          staticClass: "api-box inline",
          class: { inline: !_vm.roomUser.desc },
        },
        [
          _c("label", { staticClass: "api-title" }, [_vm._v("list")]),
          _vm._v(" roomId:"),
          _c("input", { attrs: { type: "text", name: "roomId" } }),
          _c("button", { on: { click: _vm.getRoomUserList } }, [_vm._v("OK")]),
          !!_vm.roomUser.desc
            ? _c("div", [
                _c("pre", [
                  _vm._v("userCnt: " + _vm._s(_vm.roomUser.desc.length) + "명"),
                  _c("br"),
                  _vm._v(_vm._s(_vm.roomUser.desc)),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "api-box" }, [
        _c("label", { staticClass: "api-title" }, [_vm._v("leave")]),
        _vm._v(" roomId:"),
        _c("input", { attrs: { type: "text", name: "roomId" } }),
        _vm._v(" userId:"),
        _c("input", { attrs: { type: "text", name: "userId" } }),
        _c("button", { on: { click: _vm.leave } }, [_vm._v("OK")]),
      ]),
      _c("div", { staticClass: "api-box" }, [
        _c("label", { staticClass: "api-title" }, [_vm._v("leave all")]),
        _vm._v(" roomId:"),
        _c("input", { attrs: { type: "text", name: "roomId" } }),
        _c("button", { on: { click: _vm.leaveAll } }, [_vm._v("OK")]),
      ]),
      _c("div", { staticClass: "api-box" }, [
        _c("label", { staticClass: "api-title" }, [_vm._v("req reEnter")]),
        _vm._v(" roomId:"),
        _c("input", { attrs: { type: "text", name: "roomId" } }),
        _vm._v(" userId:"),
        _c("input", { attrs: { type: "text", name: "userId" } }),
        _c("button", { on: { click: _vm.reqReEnter } }, [_vm._v("OK")]),
      ]),
      _c("div", { staticClass: "api-box" }, [
        _c("label", { staticClass: "api-title" }, [_vm._v("req reEnterAll")]),
        _vm._v(" roomId:"),
        _c("input", { attrs: { type: "text", name: "roomId" } }),
        _c("button", { on: { click: _vm.reqReEnterAll } }, [_vm._v("OK")]),
      ]),
      _c("div", { staticClass: "api-box" }, [
        _c("label", { staticClass: "api-title" }, [_vm._v("gc roomUser")]),
        _c("input", {
          attrs: {
            type: "number",
            name: "beforeEnterDateMinutes",
            value: "1440",
          },
        }),
        _vm._v(" 분전 입장자들을 한번에 "),
        _c("input", { attrs: { type: "number", name: "limit", value: "100" } }),
        _vm._v(" 번 처리하고 최대 "),
        _c("input", { attrs: { type: "number", name: "maxLoop", value: "1" } }),
        _vm._v(" 번 반복한다. "),
        _c("button", { on: { click: _vm.gcRoomUser } }, [_vm._v("OK")]),
        _c("span", { staticClass: "desc-inline" }),
      ]),
      _c("div", { staticClass: "api-box" }, [
        _c("label", { staticClass: "api-title" }, [
          _vm._v("roomUser ws session size"),
        ]),
        _c("button", { on: { click: _vm.wsSessionSize } }, [_vm._v("OK")]),
        _c("span", { staticClass: "desc-inline" }),
      ]),
      _c("div", { staticClass: "api-box" }, [
        _c("label", { staticClass: "api-title" }, [
          _vm._v("roomUser ws serverId"),
        ]),
        _vm._v(" roomId:"),
        _c("input", { attrs: { type: "text", name: "roomId" } }),
        _vm._v(" userId:"),
        _c("input", { attrs: { type: "text", name: "userId" } }),
        _c("button", { on: { click: _vm.roomUserWsServerId } }, [_vm._v("OK")]),
        _c("span", { staticClass: "desc-inline" }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }